<template>
	<div class="MyHeader">
		<div>
			<span class="header_span_1">Homie双涵公寓v4.0</span>
			<!-- 导航折叠按钮 -->
			<el-button :icon="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="qiehuan" class="goos-button"
				v-show="!shouldHideButton"></el-button>
		</div>

		<!-- 下拉框 -->
		<div class="DeleteLogin">
			<el-button style="margin-right: 1rem;background-color: transparent;border: none;" @click="GoDashboard()" size="mini">
				<i class="el-icon-full-screen" style="font-size: 1rem;color: #ffff;"></i>
			</el-button>
			<el-button style="margin-right: 1rem;background-color: transparent;border: none;" @click="color()" size="mini">
				<i :class="icon" style="font-size: 1rem;color: #ffff;"></i>
			</el-button>
			<el-dropdown @command="DeleteLogin">
				<span class="el-dropdown-link">
					<span style="color: #fff;">{{ username }}</span>
					<i class="el-icon-arrow-down el-icon--right" style="color: #fff;"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="1">个人中心</el-dropdown-item>
					<el-dropdown-item command="3">

						{{ buttonLabel }}

					</el-dropdown-item>
					<el-dropdown-item command="2">退出登录</el-dropdown-item>

				</el-dropdown-menu>
			</el-dropdown>
		</div>

		<!-- 弹窗 -->
		<el-dialog :title="dialogTitle" :visible.sync="centerDialogVisible" :width="command == 2 ? '30%' : '40%'" center
			class="tc">
			<!-- 退出登录 -->
			<div v-if="command == 2" style="display: flex;flex-direction: column;justify-content: center;">
				<div style="text-align: center;">
					<div style="font-size: 18px">确定要退出吗？</div>
				</div>
				<div>
					<span slot="footer" class="bottom_button">
						<el-button @click="centerDialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="loginout()">确 定</el-button>
					</span>
				</div>
			</div>

			<!-- 个人中心 -->
			<div class="grzx" v-else style="display: flex;justify-content: space-between;">
				<!-- 个人信息 -->
				<div style="width: 45%;">
					<span>个人信息:</span>
					<div style="margin: 1rem;"></div>
					<el-input placeholder="请输入姓名" v-model="aloneEdit.name" clearable></el-input>
					<div style="margin: 1rem;"></div>
					<el-input placeholder="请输入邮箱" v-model="aloneEdit.email" clearable></el-input>
					<div style="margin: 1rem;"></div>
					<el-input placeholder="请输入手机号" v-model="aloneEdit.phone" clearable></el-input>
					<div style="margin: 1rem;"></div>
					<el-input type="textarea" placeholder="请输入备注" v-model="aloneEdit.remark" clearable></el-input>
					<div>
						<span slot="footer" class="bottom_button">
							<el-button type="primary" @click="qx(1)">提交个人信息</el-button>
						</span>
					</div>
				</div>
				<!-- 修改密码 -->
				<div style="width: 45%;">
					<span>修改密码:</span>
					<div style="margin: 1rem;"></div>
					<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel">
						<el-form-item v-for="(item,index) in dialog_span" :key="index" :prop="item.model">
							<el-input v-model="inputmodel[`${item.model}`]" :placeholder="item.name" autocomplete="off"></el-input>
						</el-form-item>
					</el-form>
					<div>
						<div style="margin: 4.5rem;"></div>
						<span slot="footer" class="bottom_button">
							<el-button type="primary" @click="qx()">修改密码</el-button>
						</span>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		administrator_aloneEdit,
		administrator_aloneChangePwd
	} from "@/api/api.js";
	import {
		addColor
	} from '@/style/configColor.js';

	export default {
		data() {
			return {
				isCollapse: false,
				username: "公寓管理员",
				centerDialogVisible: false,
				command: '1',
				dialogTitle: '',
				buttonLabel: '',
				aloneEdit: {
					name: '',
					email: '',
					phone: '',
					remark: ''
				},
				dialog_span: [{
						name: '请输入旧密码',
						model: 'oldpassword'
					},
					{
						name: '请输入新密码',
						model: 'password'
					},
					{
						name: '请重复输入新密码',
						model: 'repassword'
					}
				],
				inputmodel: {
					oldpassword: '',
					password: '',
					repassword: ''
				},
				rules: {},
				icon: 'el-icon-moon',
				shouldHideButton: false,
			};
		},
		methods: {
			qiehuan() {
				this.isCollapse = !this.isCollapse;
				this.$emit("getData", this.isCollapse);
			},
			loginout() {
				this.centerDialogVisible = false;
				sessionStorage.removeItem("token");
				sessionStorage.removeItem("Personal_Center");
				sessionStorage.removeItem("MenuIndex");
				sessionStorage.clear();
				localStorage.clear();
				this.$router.push('/login');
			},
			DeleteLogin(command) {
				if (command == 3) {
					this.toggleMyTable()
					return
				}
				this.command = command;
				this.dialogTitle = command == 1 ? '个人中心' : '提示';
				this.centerDialogVisible = true;
			},
			qx(i) {
				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							administrator_aloneChangePwd(this.inputmodel).then(res => {
								this.Messages(res);
							});
						}
					});
				} else {
					administrator_aloneEdit(this.aloneEdit).then(res => {
						this.Messages(res);
					});
				}
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
			color() {
				if (this.icon == 'el-icon-moon') {
					this.icon = "el-icon-sunny";
					addColor('blue');
				} else {
					this.icon = 'el-icon-moon';
					addColor();
				}
			},
			GoDashboard() {
				this.$router.push('/Dashboard');
			},
			updateShouldHideButton() {
				const width = window.innerWidth;
				const ua = navigator.userAgent || navigator.platform;

				// 判断屏幕宽度 <= 1030px 或者是平板设备（含小米平板、iPad、Android 平板）
				const isSmallScreen = width <= 1030;
				const isIpad = /iPad/.test(ua);
				const isAndroidTablet = /Android.*\bTablet\b/i.test(ua) || /XiaoMi/.test(ua) || /M\d{7,}/.test(ua); // 更宽松地匹配小米设备

				this.shouldHideButton = isSmallScreen || isIpad || isAndroidTablet;
			},
			toggleMyTable() {
				// 查找类名为 MyTable 的元素（el-table 会被渲染为 table 外层的 div）
				const tableElement = document.querySelector('.MyTable');
				const tableElement2 = document.querySelector('.Mycell');

				if (!tableElement && !tableElement2) {
					console.warn('未找到类名为 MyTable 的元素');
					return;
				}

				// 获取当前 display 值
				const currentDisplay = window.getComputedStyle(tableElement).display;
				if (currentDisplay === 'none') {
					tableElement.style.display = 'block';
					tableElement2.style.display = 'none';
					this.buttonLabel = '显示卡片';
				} else {
					tableElement.style.display = 'none';
					tableElement2.style.display = 'block';
					this.buttonLabel = '显示表格';
				}

				console.log('当前 display:', tableElement.style.display);
				console.log('当前 Mycell:', tableElement2.style.display);
			}
		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}];
			}
			const {
				data
			} = JSON.parse(sessionStorage.getItem('/login'));
			this.username = data.name
			const isMinimized = sessionStorage.getItem('minw') === 'true'; // 显式转布尔
			this.buttonLabel = isMinimized ? '显示表格' : '显示卡片';

		},
		mounted() {
			this.updateShouldHideButton();
			window.addEventListener('resize', this.updateShouldHideButton);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.updateShouldHideButton);
		}
	};
</script>

<style lang="less" scoped>
	.MyHeader {
		background-color: var(--background);
		height: 100%;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.header_span_1 {
			color: #fff;
			font-size: 1.25rem;
			margin-left: 2.25rem;
		}

		.goos-button {
			background-color: transparent;
			border-color: transparent;
			color: #fff;
		}

		.DeleteLogin {
			margin-right: 2.25rem;
		}
	}

	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}
</style>

<style scoped>
	@media (max-width: 1030px),
	(max-device-width: 1030px) and (orientation: landscape) {
		.goos-button {
			display: none !important;
		}

		.header_span_1 {
			font-size: 1.6rem !important;
		}

		>>>.el-dialog {
			width: 90% !important;
		}

		.grzx {
			width: 100% !important;
		}

		.el-input {
			width: 100% !important;
			font-size: 1rem;
		}
	}
</style>